import { api } from './api';

export const getAdmins = () => api.get('/admin/super/admins');
export const createAdmin = (data: { name: string; email: string; password: string }) =>
  api.post('/admin/super/admins', data);
export const updateAdminStatus = (id: string, data: { status: string }) =>
  api.patch(`/admin/super/admins/${id}`, data);
